// extracted by mini-css-extract-plugin
export default {"main":"WordRange_main__IRNQj","question":"WordRange_question__YYyyZ","tooltip":"WordRange_tooltip__Kx0fu","word_range":"WordRange_word_range__Dm11U"};